import React from "react";
import { packClasses } from "Utils";

export default function NarrowContainer({ children, className, ...remainder }) {
    return (
        <div
            className={packClasses(
                "mx-auto max-w-7xl px-4 sm:px-6 lg:px-8",
                className
            )}
            {...remainder}
        >
            <div className="mx-auto max-w-3xl">{children}</div>
        </div>
    );
}
